import type { GlobalThemeOverrides } from 'naive-ui'

export const uiOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: '#FFF100', // your primary color
    primaryColorHover: '#FFF100',
    borderRadius: '8px',
    fontSize: '14px',
  },
  Button: {
    paddingLarge: '8px 16px',
    textColorPrimary: '#000000',
    textColorHoverPrimary: '#000000',
    textColorPressedPrimary: '#000000',
    textColorFocusPrimary: '#000000',
    colorHoverPrimary: 'rgba(255, 241, 0, 0.65)',
    colorPressedPrimary: 'rgba(255, 241, 0, 0.65)',

    //remove focused color to highlight only the selected button in Arbeitskorb filter
    borderFocus: 'rgb(224, 224, 230)',
    textColorFocus: '#000000',

    colorSecondary: 'rgba(46, 51, 56, 0.12)',
    colorHoverSecondary: 'rgba(46, 51, 56, 0.15)',
    colorPressedSecondary: 'rgba(46, 51, 56, 0.15)',
    colorFocusSecondary: 'rgba(46, 51, 56, 0.15)',
  },
  Menu: {
    // ACTIVE item text
    itemTextColorActive: '#000000',
    itemTextColorActiveHover: '#000000',
    itemTextColorChildActive: '#000000',

    // ACTIVE item background
    itemColorActive: '#FFF100',
    itemColorActiveHover: 'rgba(255, 241, 0, 0.65)',
    itemColorActiveCollapsed: 'rgba(255, 241, 0, 0.45)',
  },
  Card: {
    borderColor: 'rgba(0, 0, 0, 0.12)',
  },
  InternalSelectMenu: {
    optionCheckColor: '#000000',
    optionColorSelected: '#FFF100',
    optionTextColorActive: '#000000',
    optionTextColor: '#000000',
    optionColorActivePending: 'rgba(255, 241, 0, 0.65)',
    optionColorPending: 'rgba(46, 51, 56, 0.06)',
  }
}
